import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { A as AccordionTabsType, a as AccordionTabsAppearance } from './roche-accordion-tabs.types.js';
import { D as DomService, T as TrackingService } from './index3.js';
import { H as HistoryService, V as VisibilityManager } from './index2.js';
import { t as throttle } from './throttle.js';

const rocheAccordionTabsCss = "roche-accordion-tabs{display:block;margin-top:3rem}@media (min-width: 90rem){roche-accordion-tabs{margin-top:4.5rem}}roche-accordion-tabs,roche-accordion-tabs *{box-sizing:border-box}roche-accordion-tabs[no-margin]{margin-top:0}@media (min-width: 64rem){roche-accordion-tabs[no-margin]{margin-top:0}}roche-accordion-tabs .tabs{display:flex;overflow-x:auto;padding:0;margin:0;border-bottom:1px solid #c2bab5;opacity:0;pointer-events:none;scrollbar-width:none;position:relative;z-index:50}roche-accordion-tabs .tabs::-webkit-scrollbar{display:none}roche-accordion-tabs .tabs li{display:inline-block;list-style:none}roche-accordion-tabs .tabs li+li{margin-left:1.5rem}@media (min-width: 48rem){roche-accordion-tabs .tabs li+li{margin-left:2rem}}roche-accordion-tabs .tabs--visible{height:auto;opacity:1;pointer-events:all}roche-accordion-tabs .tabs__item{all:unset;padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.125rem;line-height:1.6875rem;position:relative;color:#544f4f;cursor:pointer;white-space:nowrap;padding-bottom:0.5rem;border-bottom:0.1875rem solid transparent;transition:border-color 100ms ease-in, color 100ms ease-in}roche-accordion-tabs .tabs__item strong{font-weight:600}@media (min-width: 48rem){roche-accordion-tabs .tabs__item{font-size:1.125rem;line-height:1.8125rem}}@media (min-width: 90rem){roche-accordion-tabs .tabs__item{font-size:1.25rem;line-height:1.875rem}}@media (min-width: 48rem){roche-accordion-tabs .tabs__item{padding-bottom:1rem}}roche-accordion-tabs .tabs__item:focus,roche-accordion-tabs .tabs__item:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:-2px}roche-accordion-tabs .tabs__item:focus:not(:focus-visible){outline:none}roche-accordion-tabs .tabs__item:hover{border-bottom-color:var(--color-interactive--primary-hover)}roche-accordion-tabs .tabs__item.active{border-bottom-color:var(--color-interactive--primary-hover);color:var(--color-interactive--primary-hover)}roche-accordion-tabs .tabs--centered.tabs--visible{display:table;margin-left:auto;margin-right:auto}roche-accordion-tabs .tabs--centered .tabs__item{padding-left:1rem;padding-right:1rem;text-align:center}roche-accordion-tabs[blur-ends=both] .tabs{mask-image:linear-gradient(to right, transparent 0%, black 4rem), linear-gradient(to left, transparent 0%, black 4rem);mask-composite:intersect;-webkit-mask-image:linear-gradient(to right, transparent 0%, black 4rem), linear-gradient(to left, transparent 0%, black 4rem);-webkit-mask-composite:intersect}@supports selector(::-internal-media-controls-overlay-cast-button){roche-accordion-tabs[blur-ends=both] .tabs{-webkit-mask-composite:source-in}}roche-accordion-tabs[blur-ends=left] .tabs{mask-image:linear-gradient(to right, transparent 0%, black 4rem);-webkit-mask-image:linear-gradient(to right, transparent 0%, black 4rem)}roche-accordion-tabs[blur-ends=right] .tabs{mask-image:linear-gradient(to left, transparent 0%, black 4rem);-webkit-mask-image:linear-gradient(to left, transparent 0%, black 4rem)}roche-accordion-tabs[appearance=filter] .tabs{border-bottom:none}roche-accordion-tabs[appearance=filter] .tabs__item{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;font-weight:400;display:inline;position:relative;border:1px solid #dbd6d1;padding:0.34375rem 1rem;color:#544f4f;white-space:nowrap}@media (min-width: 64rem){roche-accordion-tabs[appearance=filter] .tabs__item{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}@media (min-width: 90rem){roche-accordion-tabs[appearance=filter] .tabs__item{font-size:1.125rem;line-height:1.8125rem}}roche-accordion-tabs[appearance=filter] .tabs__item:focus,roche-accordion-tabs[appearance=filter] .tabs__item:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}roche-accordion-tabs[appearance=filter] .tabs__item:focus:not(:focus-visible){outline:none}roche-accordion-tabs[appearance=filter] .tabs__item:hover,roche-accordion-tabs[appearance=filter] .tabs__item.active{background-color:var(--color-interactive--primary-hover);border-color:var(--color-interactive--primary-hover);color:#fff;transition:background-color 200ms ease, border-color 200ms ease, color 200ms ease;text-decoration:none}roche-accordion-tabs[appearance=filter] .tabs__item:hover:not(.tabs__item.active){background-color:#eae8e5;border-color:#706b69;color:#544f4f;cursor:pointer}roche-accordion-tabs[appearance=filter] .tabs li+li{margin-left:1.5rem}@media (min-width: 48rem){roche-accordion-tabs[appearance=filter] .tabs li+li{margin-left:1rem}}roche-accordion-tabs[appearance=pipeline] .tabs{border-bottom:none}roche-accordion-tabs[appearance=pipeline] .tabs__item{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;font-weight:400;display:inline;position:relative;border:1px solid #9d948e;padding:0.34375rem 1rem;color:#9d948e;white-space:nowrap}@media (min-width: 64rem){roche-accordion-tabs[appearance=pipeline] .tabs__item{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}@media (min-width: 90rem){roche-accordion-tabs[appearance=pipeline] .tabs__item{font-size:1.125rem;line-height:1.8125rem}}roche-accordion-tabs[appearance=pipeline] .tabs__item:focus,roche-accordion-tabs[appearance=pipeline] .tabs__item:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}roche-accordion-tabs[appearance=pipeline] .tabs__item:focus:not(:focus-visible){outline:none}roche-accordion-tabs[appearance=pipeline] .tabs__item:hover,roche-accordion-tabs[appearance=pipeline] .tabs__item.active{background-color:#9d948e;border-color:#9d948e;color:#fff;transition:background-color 200ms ease, border-color 200ms ease, color 200ms ease;text-decoration:none}roche-accordion-tabs[appearance=pipeline] .tabs__item:hover:not(.tabs__item.active){background-color:#eae8e5;border-color:#706b69;color:#544f4f;cursor:pointer}roche-accordion-tabs[appearance=pipeline] .tabs li+li{margin-left:1.5rem}@media (min-width: 48rem){roche-accordion-tabs[appearance=pipeline] .tabs li+li{margin-left:1rem}}roche-accordion-tabs[dir=rtl] .tabs li+li{margin-right:1.5rem;margin-left:0}@media (min-width: 48rem){roche-accordion-tabs[dir=rtl] .tabs li+li{margin-right:2rem;margin-left:0}}";
const RocheAccordionTabsStyle0 = rocheAccordionTabsCss;

const RocheAccordionTabs = /*@__PURE__*/ proxyCustomElement(class RocheAccordionTabs extends HTMLElement {
    get items() {
        return Array.from(this.element.children).filter((child) => child.tagName.toLowerCase() === 'roche-accordion-tabs-item');
    }
    get childrenCentered() {
        return this.centered && this.element.querySelectorAll('roche-accordion-tabs-item').length <= 2;
    }
    get defaultTracking() {
        return {
            component_name: 'roche-accordion-tabs',
            event: this.type === AccordionTabsType.TABS ? 'tabs_click' : 'accordion_click',
        };
    }
    constructor() {
        super();
        this.__registerHost();
        this.toggleEventSearch = createEvent(this, "rocheTabChange", 7);
        this.handleHashChange = () => {
            const currentUrl = HistoryService.getActiveUrl();
            if (currentUrl.hash === '') {
                setTimeout(() => {
                    this.handleToggle(this.startPosition, true);
                }, 100);
            }
        };
        this.handleTabHeaderScroll = (event) => {
            event.preventDefault();
            this.tabHeader.scrollLeft += (event.deltaY + event.deltaX);
        };
        this.type = AccordionTabsType.TABS;
        this.startPosition = undefined;
        this.centered = false;
        this.appearance = AccordionTabsAppearance.DEFAULT;
        this.refresh = undefined;
        this.blurEnds = undefined;
        this.noMargin = false;
        this.alwaysPersistFirstTabId = false;
        this.lastOpen = undefined;
        this.isOpen = false;
        this.setBlurStates = throttle(this.setBlurStates.bind(this), 80);
        this.trackHeaderOnPageLoad = this.trackHeaderOnPageLoad.bind(this);
    }
    async syntheticHandleToggle(index) {
        // prevent closing already opened accordion items
        if (this.lastOpen === index) {
            return;
        }
        this.handleToggle(index, true);
    }
    onStartPositionChanged(newValue) {
        this.lastOpen = newValue;
    }
    handleToggle(event, isSynthetic) {
        if (this.hasAccordionTabsAncestor && event instanceof CustomEvent) {
            event.stopPropagation();
        }
        const index = typeof event === 'number'
            ? event
            : this.items.findIndex((item) => item === event.detail.element);
        /**
         * 1. For user interaction triggered events, persist the opened tab/accordion item in the URL.
         *    For "synthetic" interaction cases don't.
         *    The data will already be up to date in synthetic cases.
         *    (ex: VisibilityManager requests a tab to be opened so it can display a child)
         * 2. Skip setting the hash of the default open item
         *    2.1) when the page is first loaded.
         *    2.2) when the user is switching manually AND alwaysPersistFirstTabId is false.
         */
        const isUserTriggered = !isSynthetic;
        this.scrollNthTabIntoView(index);
        this.isOpen = this.type === AccordionTabsType.TABS
            || this.lastOpen !== index
            || !this.isOpen;
        if (this.lastOpen !== index) {
            this.toggleEventSearch.emit({
                triggered: isUserTriggered,
                activeTabId: this.items[index].id,
            });
            this.trackHeaderByIndex(index);
        }
        this.lastOpen = index;
        if (!isUserTriggered) {
            return;
        }
        let openIndexAtPageLoad = Number.isNaN(this.startPosition)
            ? undefined
            : this.startPosition;
        if (!openIndexAtPageLoad && this.type === AccordionTabsType.TABS) {
            openIndexAtPageLoad = 0;
        }
        const openChild = this.items[index];
        const openChildId = (openIndexAtPageLoad !== index || this.alwaysPersistFirstTabId)
            ? openChild === null || openChild === void 0 ? void 0 : openChild.id
            : '';
        if (index !== this.startPosition || isUserTriggered) {
            VisibilityManager.setAsVisible(openChildId, openChild);
        }
    }
    getAccordionTabsAncestor() {
        const ancestor = DomService.closestElement(this.element.tagName.toLocaleLowerCase(), this.element.parentElement);
        return ancestor !== null;
    }
    scrollNthTabIntoView(n) {
        var _a;
        if (this.type === AccordionTabsType.ACCORDION) {
            return;
        }
        const target = this.element.querySelectorAll('li')[n];
        if (!target) {
            return;
        }
        const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
        const left = targetLeft
            - ((_a = this.tabHeader) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left)
            - targetWidth;
        this.tabHeader.scrollBy({
            left,
            behavior: 'smooth',
        });
    }
    componentWillLoad() {
        window.addEventListener('onetrustInitialized', this.trackHeaderOnPageLoad);
        const shouldStartOpened = this.startPosition >= 0
            && this.startPosition < this.items.length;
        if (shouldStartOpened) {
            this.isOpen = true;
            this.lastOpen = this.startPosition;
        }
        else if (this.type === AccordionTabsType.TABS) {
            this.isOpen = true;
            this.lastOpen = 0;
        }
    }
    componentWillRender() {
        this.updateItems();
    }
    componentDidRender() {
        if (this.type === AccordionTabsType.TABS) {
            this.setBlurStates();
        }
    }
    componentDidLoad() {
        this.hasAccordionTabsAncestor = this.getAccordionTabsAncestor();
        window.addEventListener('popstate', this.handleHashChange);
        if (this.childrenCentered) {
            this.updateCenteredItems();
        }
        if (this.type === AccordionTabsType.TABS) {
            this.tabHeader.addEventListener('wheel', this.handleTabHeaderScroll);
            this.tabHeader.addEventListener('scroll', this.setBlurStates);
        }
        DomService.handleTextDirection(this.element);
    }
    disconnectedCallback() {
        this.tabHeader.removeEventListener('wheel', this.handleTabHeaderScroll);
        this.tabHeader.removeEventListener('scroll', this.setBlurStates);
        window.removeEventListener('hashchange', this.handleHashChange);
    }
    render() {
        const classNames = {
            tabs: true,
            'tabs--visible': this.type === AccordionTabsType.TABS,
            'tabs--centered': this.childrenCentered,
        };
        return (h(Host, { key: 'cde01e32ede09946beaae45a34b59314a9c7c4fd', appearance: true }, h("ul", { key: 'e9385c7682cb951856755fde216785691d54ebdb', class: classNames, ref: (element) => { this.tabHeader = element; } }, this.items.map((item, index) => (h("li", { key: index }, h("button", { class: { tabs__item: true, active: this.lastOpen === index }, onClick: () => this.handleToggle(index) }, item.headline))))), h("slot", { key: '213f90af669ea90340d1adbd6464ba4a392f8bff' })));
    }
    updateItems() {
        const { items } = this;
        const shouldBeOpened = this.type === AccordionTabsType.TABS || this.isOpen;
        items.forEach((item) => {
            item.setAttribute('type', this.type);
            if (items[this.lastOpen] === item && shouldBeOpened) {
                item.setAttribute('open', '');
            }
            else {
                item.removeAttribute('open');
            }
        });
    }
    updateCenteredItems() {
        let tabsItemWidth = 0;
        const tableItems = this.element.querySelectorAll('.tabs__item');
        tableItems.forEach((element) => {
            const computedStyle = window.getComputedStyle(element);
            const elementPaddingLeft = parseInt(computedStyle.paddingLeft.replace('px', ''), 10);
            const elementPaddingRight = parseInt(computedStyle.paddingRight.replace('px', ''), 10);
            const elementWidth = element.offsetWidth + elementPaddingLeft + elementPaddingRight;
            if (tabsItemWidth < elementWidth) {
                tabsItemWidth = elementWidth;
            }
        });
        tableItems.forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            element.style.width = `${tabsItemWidth}px`;
        });
    }
    setBlurStates() {
        if (this.isLeftBlur() && this.isRightBlur()) {
            this.blurEnds = 'both';
        }
        else if (this.isLeftBlur()) {
            this.blurEnds = 'left';
        }
        else if (this.isRightBlur()) {
            this.blurEnds = 'right';
        }
        else {
            this.blurEnds = 'none';
        }
    }
    isLeftBlur() {
        // scrollLeft works differntly with rtl
        return DomService.isRtl(this.element)
            ? this.tabHeader.scrollLeft - 2 > this.tabHeader.clientWidth - this.tabHeader.scrollWidth
            : this.tabHeader.scrollLeft > 0;
    }
    isRightBlur() {
        // scrollLeft works differntly with rtl
        return DomService.isRtl(this.element) ? this.tabHeader.scrollLeft < 0
            : this.tabHeader.scrollLeft < this.tabHeader.scrollWidth - this.tabHeader.clientWidth;
    }
    trackHeaderByIndex(index) {
        var _a;
        const header = (_a = this.tabHeader) === null || _a === void 0 ? void 0 : _a.childNodes[index];
        TrackingService.push(Object.assign(Object.assign({}, this.defaultTracking), { value: header ? header.textContent : undefined }));
    }
    trackHeaderOnPageLoad() {
        if (this.startPosition) {
            this.trackHeaderByIndex(this.startPosition);
            window.removeEventListener('onetrustInitialized', this.trackHeaderOnPageLoad);
        }
    }
    get element() { return this; }
    static get watchers() { return {
        "startPosition": ["onStartPositionChanged"]
    }; }
    static get style() { return RocheAccordionTabsStyle0; }
}, [4, "roche-accordion-tabs", {
        "type": [1],
        "startPosition": [2, "start-position"],
        "centered": [4],
        "appearance": [513],
        "refresh": [516],
        "blurEnds": [1537, "blur-ends"],
        "noMargin": [4, "no-margin"],
        "alwaysPersistFirstTabId": [4, "always-persist-first-tab-id"],
        "lastOpen": [32],
        "isOpen": [32],
        "syntheticHandleToggle": [64]
    }, [[0, "rocheAccordionTabsItemToggle", "handleToggle"]], {
        "startPosition": ["onStartPositionChanged"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-accordion-tabs"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-accordion-tabs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheAccordionTabs);
            }
            break;
    } });
}

export { RocheAccordionTabs as R, defineCustomElement as d };

//# sourceMappingURL=roche-accordion-tabs2.js.map